import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import cn from 'classnames';
import FbTabsSection from '../FbTabsSection';
import TabPanel from '../TabPanel';

const useStyles = makeStyles(() => ({
  root: { width: '100%' },
  displaySection: {
    padding: '20px',
  },
  mainSection: {
    width: '55%',
    marginRight: 30,
  },
  sideSection: {
    width: '45%',
  },
  onlySide: {
    flex: '1 1',
  },
  onlyMain: {
    marginRight: 0,
    width: '100%',
  },
  '@media (max-width: 1100px)': {
    displaySection: {
      flexWrap: 'wrap',
    },
    mainSection: {
      flex: '1 1 100%',
      width: '100%',
      marginRight: 0,
      marginBottom: 20,
    },
    sideSection: {
      flex: '1 1 100%',
    },
  },
  tabPanel: {
    width: '100%',
    display: 'flex',
  },
  tabsSection: {
    boxShadow: '0 20px 20px -20px rgba(0, 0, 0, 0.1)',
  },
}));

const StubContent = ({ className, tabs, InfoCard, selectedTab, onChange }) => {
  const classes = useStyles();
  return (
    <div className={cn(classes.root, className)}>
      {InfoCard && <InfoCard />}
      {tabs && (
        <FbTabsSection
          appBarClass={classes.tabsSection}
          tabs={tabs}
          onChange={onChange}
          initialTabValue={selectedTab}
          scrollable
        />
      )}
      <div className={classes.displaySection}>
        {tabs.map((item, index) => (
          <TabPanel value={selectedTab} currentVal={item.value} key={`tab-${index}`} className={classes.tabPanel}>
            {item.mainContent && (
              <div className={cn(classes.mainSection, { [classes.onlyMain]: !item.sidebarContent })}>
                {item.mainContent}
              </div>
            )}
            {item.sidebarContent && (
              <div className={cn(classes.sideSection, { [classes.onlySide]: !item.mainContent })}>
                {item.sidebarContent}
              </div>
            )}
          </TabPanel>
        ))}
      </div>
    </div>
  );
};

StubContent.propTypes = {
  className: PropTypes.string,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      href: PropTypes.string,
    }),
  ),
  InfoCard: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
};

export default StubContent;
